import {
    Footer,
    FooterLegalProps,
    FooterPaymentMethodsProps,
    FooterPrimaryProps,
    FooterSecondaryProps,
} from '@goed/ui-components';
import { LanguageLink } from '../../language-link';
import Link from 'next/link';

type FooterProps = {
    primary: FooterPrimaryProps['primary'];
    secondary: FooterSecondaryProps['secondary'];
    payments: FooterPaymentMethodsProps['paymentMethods'];
    tertiary: FooterLegalProps['legal'];
};

export const GoedBeFooter = ({ footer }: { footer: { goedBeFooter: FooterProps } }) => {
    if (!footer.goedBeFooter) return <></>;

    const translations = {
        togetherWith: 'samen met',
        vat: 'BTW',
    };

    return (
        <Footer
            footer={footer.goedBeFooter}
            translations={translations}
            cmLogo="/assets/images/png/cm-footer.png"
            linkComponent={LanguageLink}
        />
    );
};
